"use strict";

module.exports = {
  buttons: {
    backLink: "GERİ",
    cancelButton: "İPTAL",
    chatWithAgentButton: "BİR TEMSİLCİYLE SOHBET BAŞLATIN",
    closeButton: "KAPAT",
    contactSupportButton: '<a href="" class="adsktm-show-contact-support-btn">DESTEK İLE İLETİŞİME GEÇİN</a>',
    copiedButton: "KOPYALANDI",
    copyButton: "KOPYALA",
    getStartedButton: "BAŞLAYIN",
    haveAQuestion: "Bir sorunuz mu var?",
    helpPanel: '<a target="_blank" href="https://knowledge.autodesk.com/tr/contact-support/installation-activation/activation-registration">BİR SORUNUZ MU VAR?</a>',
    nextButton: "İLERİ",
    requiredLabel: "Gerekli",
    restartButton: "BAŞTAN BAŞLA",
    signInButton: "OTURUM AÇ",
    submitAgainButton: "TEKRAR GÖNDER",
    submitButton: "GÖNDER",
    tryAgainButton: "TEKRAR DENEYİN",
    notNow: "ŞİMDİ DEĞİL",
    validate: "ONAYLA"
  },
  signIn: {
    gatheringInfo: "Hesap bilgileriniz toplanıyor",
    helloUser: "Merhaba <first-name>!",
    justAMoment: "Lütfen bekleyin...",
    signInNow: "<a>Hemen oturum açın</a>",
    signInHelp: "<a target=\"_blank\" href=\"https://knowledge.autodesk.com/tr/contact-support/account-management/account-creation-sign-profile-management\">Giri\u015F yapmakta sorun mu ya\u015F\u0131yorsunuz?</a>",
    startAccessAccount: "Hesabınıza giriş yaparak başlayalım."
  },
  contactOptions: {
    addtlComments: "İlave yorumlar (tercihe bağlı)",
    addtlCommentsMsg: "Destek talebinizi yukarıdaki bilgilerle oluşturacağız. Bu boşluğa bilmemiz gereken diğer tüm bilgileri ekleyin.",
    addtlCommentsReqd: "A&ccedil;ıklama",
    agentAvailable: "Temsilci müsait",
    agentAvailableStdby: "Temsilci müsait, lütfen bekleyin",
    agentUnavailable: "Temsilci müsait değil",
    cancelCase: "DESTEK TALEBİNİ İPTAL ET",
    cancelChat: "SOHBETİ İPTAL ET",
    caseConfirm1: "Kısa bir süre içinde onay e-postası alacaksınız. E-postayı almazsanız gereksiz/istenmeyen e-posta klasörünüzü kontrol edin.",
    caseConfirm2: "Bir temsilci, destek talebinizi inceleyerek 2 iş günü içinde sizinle iletişime geçecektir.",
    caseDetails: "Destek talebiyle ilgili ayrıntılar",
    caseNumber: "Destek talebi numarası: <case-number>",
    caseSubmitted: "Destek talebi gönderildi",
    chatWithAgent: "Bir temsilciyle sohbet başlatın",
    closingWindowMsg: "Bağlanmadan önce bu pencereyi kapatırsanız sohbet iptal edilebilir",
    connectMomentarily: "Kısa bir süre içinde sizinle iletişime geçilecektir.",
    createCase: "Destek talebi oluşturun",
    errorLabel: "Hata",
    forceStartChat: "<a>Sohbete başlamak için buraya tıklayın.</a>",
    getCaseAnswer2Days: "2 gün içinde cevap alın",
    mayCloseWindow: "Şimdi bu pencereyi kapatabilirsiniz.",
    note: "NOT:",
    orSubmitCase: "Veya bunun yerine <a>destek talebi gönderin<a/>, bir temsilci 2 iş günü içinde sizinle iletişime geçecektir.",
    popUpBlocker: "Açılır pencereleriniz engelleniyor mu? ",
    productLabel: "Ürün",
    sorryNoAgent: "Maalesef temsilci müsait değil",
    willUpdateAgent: "Temsilcilerden biri müsait olduğunda bu ekranı güncelleyeceğiz.",
    yourContactInfo: "İletişim bilgileriniz"
  },
  welcome: {
    important: "&Ouml;nemli:",
    noteForTheUser: "Not:"
  },
  captchaScreen: {
    correctMsg: "Doğru!",
    incorrectMsg: "Yanlış. Tekrar deneyin.",
    pageTitle: "G&uuml;venlik denetimi",
    typeCaptchaLabel: "Yukarıda g&ouml;rd&uuml;ğ&uuml;n&uuml;z karakterleri girin"
  },
  contactInfoScreen: {
    emailDisclaimer: "Onayı size gönderebilmek için bu bilgiye ihtiyacımız var.",
    emailTitle: "E-posta",
    firstNamePlaceholder: "Ad",
    lastNamePlaceholder: "Soyadı",
    nameLabel: "Ad",
    pageTitle: "1. İletişim bilgileriniz"
  },
  reviewAccountInfo: {
    differentAccount: "<a>Farklı bir hesapta oturum açın</a>",
    emailConfirm: "Bu e-posta adresini, hesabınızı inceleyip size onay göndermek için kullanacağız.",
    helloUser: "Merhaba <first-name>!",
    pageTitle: "1. Hesap bilgilerinizi gözden geçirin",
    signedInAs: "Şu bilgilerle oturum açtınız:"
  },
  processInfoScreen: {
    checkSerialMsg: "Bu seri numarasını kontrol etmek için Enter tuşuna basın.",
    continueTyping: "Bu formatta bir seri numarası yazarak devam edin: XXX-XXXXXXXX.",
    doNotNeedHula: "<strong>İyi haber!</strong> Ayrı bir ev kullanım lisansı istemenize gerek yok. Yazılımı, aynı seri numarasını kullanarak bir ev bilgisayarından yükleyip etkinleştirebilirsiniz.",
    downloadYourProduct: "&Uuml;r&uuml;n&uuml;n&uuml;z&uuml; indirin ve y&uuml;kleyin. Ek bir etkinle\u015Ftirmeye gerek yoktur.",
    emailForSerialNumPlaceholder: "İlişkili e-posta",
    emailForSerialNumTitle: "Seri numarasıyla ilişkili e-posta",
    emailForSerialNumTooltip: "Bu adres; yazılım koordinatörü, sözleşme yöneticisi veya yazılımı satın alan kişiye ait e-posta adresidir",
    ineligiblePerpetual: 'Bu seri numarası, ev kullanımına <b>uygun olmayan</b> bir kalıcı lisansa aittir.<br/><br/>Yazılım aboneliklerimiz her zaman, her yerde kullanıma açıktır. <a target="_blank" href="https://www.autodesk.com.tr/subscription">Abonelik avantajları hakkında daha fazla bilgi edinin</a>.',
    justTypeIn: "- Seri numaranız listede yoksa kutuya yazmayı deneyin. -",
    msgEducationSerialNum: "Bu bir eğitim seri numarasıdır.",
    msgGoToEducationComm: '<a target="_blank" href="https://www.autodesk.com/education/free-software/all">Eğitim Topluluğu sayfasına gidin</a>',
    msgIndustryCollectionSerialNum: "Bu seri numarası bir çözüm paketinin parçasıdır: <collection-name>",
    msgNetworkSerialNum: "Bu seri numaras\u0131 bir <Strong>a\u011F lisans\u0131na</Strong> aittir ve aktivasyon koduna gerek yoktur. Lisans\u0131n\u0131z\u0131n do\u011Fru \u015Fekilde kuruldu\u011Funu do\u011Frulamak i&ccedil;in l&uuml;tfen A\u011F Y&ouml;neticinizle ileti\u015Fime ge&ccedil;in.",
    msgSubscriptionSoftware: "Bu seri numaras\u0131 <Strong>abonelik yaz\u0131l\u0131m\u0131na</Strong> aittir ve aktivasyon koduna gerek yoktur. L&uuml;tfen internete ba\u011Fl\u0131yken &uuml;r&uuml;n&uuml;n&uuml;z&uuml; ba\u015Flat\u0131n. Daha sonra <a target=\"_blank\" href=\"https://knowledge.autodesk.com/article/subscriber-activation\">oturum a&ccedil;\u0131n</a> veya <a target=\"_blank\" href=\"https://knowledge.autodesk.com/article/online-activation-registration\">bir seri numaras\u0131 girin</a>.",
    msgBiCIndirectSoftware: "You no longer need an activation code because your license is now part of our improved account experience. Just sign in using your Autodesk email and password to start using the software (make sure you are connected to the internet).",
    msgBicIndirectSCRole: 'The software coordinator role is not included with your license. See <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/user-management/primary-admins">Primary and Secondary admins</a> for information about the admin roles included with your license.',
    msgSN2010orOlder: 'The serial number you entered is for an older version that is no longer supported. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">See eligibility requirements</a>',
    myProductNotListed: "Ürünüm listede yok",
    noResultsMsg: "Hiçbir sonuç bulunamadı. Bu formatta bir seri numarası girin: XXX-XXXXXXXX.",
    pageTitle: "2. Ürün bilgileri",
    partOfCollection: "Ürününüz bu çözüm paketinin parçasıdır: <collection-name>",
    requestCodeTitle: "İstek kodu",
    requestCodetooltip: '<a target="_blank" href="https://www.autodesk.com/find-request-code-tur">İstek kodunuzu</a> bulma',
    selectPlaceholder: "Seçin",
    selectProduct: "Belirli bir ürün seçin",
    selectProductPlaceholder: "Ürün seçme",
    selectYourProductTitle: "Ürününüzü seçin",
    serialNumberLabel: "Seri numarası",
    serialNumberPlaceholder: "Ürün adına göre arayın - veya - bir numara yazın",
    serialNumbersInAccount: "HESABINIZDAKİ SERİ NUMARALARI",
    serialNumberTooltip: '<a target="_blank" href="https://www.autodesk.com/find-serial-number-tur">Seri numaranızı</a> bulma',
    yesOption: "Yes",
    noOption: "No",
    currentInfoTitle: "Mevcut bilgiler",
    contractNumDisclaimer: "S\xF6zle\u015Fme numaran\u0131zda bulunuyorsa k\u0131sa \xE7izgi karakterini (-) de ekleyin.",
    contractNumLabel: "Sözleşme numarası",
    contractNumTooltip: 'Sözleşme numarasını <a target="_blank" href="https://manage.autodesk.com">Hesabınızdaki</a> Faturalandırma ve Siparişler bölümünde bulabilirsiniz.'
  },
  authorizationRequestScreen: {
    enterEmail: "E-posta adresini girin",
    option1: "Bu ürünün yöneticisi, sözleşme yöneticisi veya yazılım koordinatörü olduğumu onaylıyorum.",
    option2: "Bu isteği yönetici, sözleşme yöneticisi veya yazılım koordinatörü adına gerçekleştirdiğimi onaylıyorum. E-posta adresi:",
    pageTitle: "3. Bu isteğe ilişkin yetki",
    selectOne: "Lütfen birini seçin"
  },
  processingScreen: {
    firstMsg: "İsteğiniz işleniyor",
    takingLongerExpected: "Düşündüğümüzden daha uzun sürecek, beklettiğimiz için üzgünüz.",
    updatedMsgLonger: "İşlem hâlâ devam ediyor",
    willTakeSecs: "Birkaç saniye sürebilir..."
  },
  successScreen: {
    expirationLine: "<br/>Sona erme tarihi: <expiration-date>",
    infoWillBeEmailed: "Bu bilgiler şu e-posta adresinize de gönderilecektir: <email>",
    pageTitle: "İşlem başarılı",
    prodSeatMulti: "<product-name> (<number-seats> kayıtları için)<br/>",
    prodSeatSingle: "<product-name> (1 lisans için)<br/>",
    pvApprovedMsg: "Önceki sürüm talebiniz onaylandı.",
    pvInstruction: "Aşağıdaki bilgileri kullanarak yazılımınızı yükleyin ve etkinleştirin.",
    reponseText: "Aktivasyon kodunuz: <activation-code>",
    responseText1: "Ev kullanım lisansı isteğiniz onaylanmıştır.",
    responseText2: 'Aşağıdaki bilgileri kullanarak yazılımınızı yükleyin ve etkinleştirin. Yükleme işlemi sırasında "bağımsız" seçeneğini belirleyin.',
    responseText3: "Seri numarası: <serial-number><br/>Ürün anahtarı: <product-key>",
    updateDisclaimer: "L&uuml;tfen de\u011Fi\u015Fikli\u011Fin hesab\u0131n\u0131zda g&ouml;r&uuml;nmesi i&ccedil;in birka&ccedil; saat bekleyin."
  },
  errors: {
    emailNotAssocWithSerialNumber: "Bu e-posta adresi, bu seri numarasıyla ilişkilendirilmemiştir. ",
    enterCMSCEmail: "Bu ürünün sözleşme yöneticisi veya yazılım koordinatörünün e-posta adresini girin",
    enterComments: "Bir a&ccedil;ıklama girin",
    enterEmail: "E-posta adresinizi girin",
    enterEmailAssociated: "İlişkili e-posta adresini girin",
    enterFirstName: "Adınızı girin",
    enterLastName: "Soyadınızı girin",
    enterRequestCode: "İstek kodunuzu girin",
    enterSerialNumber: "Seri numaranızı girin",
    enterValidFormat: "Geçerli bir format girin",
    invalidAutodeskSerialNumber: '<p>Geçerli bir Autodesk seri numarası değil.</p><p>Lütfen yetkili kaynaklardan satın alınan bir yazılım kullandığınızdan emin olun:</p><ul><li><a target="_blank" href="http://www.autodesk.com/store">Autodesk Mağazası</a></li><li><a target="_blank" href="http://www.autodesk.com/resellers/locate-a-reseller">Yetkili İş Ortakları</a></li><li><a target="_blank" href="https://www.autodesk.com/education/prepare-and-excel/authorized-academic-partner">Eğitim İş Ortakları</a></li></ul>',
    invalidLicenseModel: "Bu ürün, geçersiz bir lisans modeline sahip.",
    invalidRequestcode: "Geçersiz istek kodu",
    invalidSerialNumber: "Geçersiz seri numarası",
    notCMSC: "Kayıtlarımıza göre bu ürünün sözleşme yöneticisi veya yazılım koordinatörü değilsiniz.",
    oops: 'İsteğiniz işlenirken bir hata oluştu. <a target="_blank" href="https://knowledge.autodesk.com/tr/contact-support/installation-activation/activation-registration">Destek ile iletişime geçin</a>',
    overActivation: "Birden fazla etkinleştirme",
    productExpired: "Etkinleştirmek istediğiniz ürünün süresi dolmuş.",
    reasonForActivation: "Etkinleştirme sebebi",
    serialNumNotAssocWithSingleLicense: "Bu seri numarası, herhangi bir tek kullanıcı lisansıyla ilişkilendirilmemiştir.",
    serialNumNotFound: "Seri numarası bulunamadı",
    serialNumNotRegisteered: 'Bu seri numarası henüz kayıtlı değil. Lütfen önce seri numarasını <a target="_blank" href="http://registeronce.autodesk.com/">kaydedin</a>.'
  },
  requestFailedScreen: {
    caseError: "Destek talebiniz gönderilirken bir hata oluştu.",
    contactOptionsBelow: "Yard\u0131ma ihtiyac\u0131n\u0131z varsa a\u015Fa\u011F\u0131daki se&ccedil;eneklerden birini kullanarak <a id=\"go-to-contact-us\" href=\"javascript:void(0);\">bizimle ileti\u015Fime ge&ccedil;in</a>.",
    expiredSubsTitle: "S&uuml;resi dolan abonelik",
    expiredSubscription: "Aboneli\u011Finizin s&uuml;resi doldu\u011Fu i&ccedil;in iste\u011Finiz tamamlanam\u0131yor. L&uuml;tfen hesap y&ouml;neticinizle g&ouml;r&uuml;\u015F&uuml;n veya yenileme se&ccedil;enekleri i&ccedil;in <a target=\"_blank\" href=\"https://manage.autodesk.com/cep/#products-services\">hesab\u0131n\u0131z\u0131</a> kontrol edin.",
    inactiveSubsTitle: "Etkin olmayan abonelik",
    noActiveSubs: "Aboneli\u011Finiz hen&uuml;z etkin olmad\u0131\u011F\u0131 veya sona erdi\u011Fi i&ccedil;in iste\u011Finiz tamamlanam\u0131yor. L&uuml;tfen hesap y&ouml;neticinizle g&ouml;r&uuml;\u015F&uuml;n veya yenileme se&ccedil;enekleri i&ccedil;in <a target=\"_blank\" href=\"https://manage.autodesk.com/cep/#products-services\">hesab\u0131n\u0131z\u0131</a> kontrol edin.",
    pageTitle2: "İstek tamamlanamıyor",
    pageTitle: "İstek başarısız oldu",
    prodNotEligibleTitle: "Ürün uygun değil",
    prodNotRegisteredTitle: "&Uuml;r&uuml;n kay\u0131tl\u0131 de\u011Fil",
    prodNotRegistered: "&Uuml;r&uuml;n&uuml;n&uuml;z hen&uuml;z kay\u0131tl\u0131 olmad\u0131\u011F\u0131 i&ccedil;in iste\u011Finiz tamamlanam\u0131yor. <br><br><a target=\"_blank\" href=\"https://registeronce.autodesk.com\">&Uuml;r&uuml;n&uuml;n&uuml;z&uuml; kaydettirin</a>",
    responseText: "Maalesef isteğiniz işlenirken bir hata oluştu."
  },
  gac: {
    welcome: {
      clickGetStarted: "Aktivasyon kodu almak i&ccedil;in Başlayın se&ccedil;eneğine tıklayın.",
      modalTitle: "Aktivasyon kodu alma",
      noteBullet1: "Yaln\u0131zca ba\u011F\u0131ms\u0131z bir kal\u0131c\u0131 lisans\u0131n\u0131z veya ba\u011F\u0131ms\u0131z e\u011Fitim lisans\u0131n\u0131z (&ouml;\u011Frenci ya da e\u011Fitmen) varsa ve <strong>internet eri\u015Fiminiz yoksa</strong> aktivasyon koduna ihtiyac\u0131n\u0131z olur.",
      noteBullet2: "<strong>\u0130nternet eri\u015Fiminiz varsa aktivasyon koduna gerek yoktur.</strong> &Uuml;r&uuml;n&uuml;n&uuml;z&uuml; ba\u015Flat\u0131p <a target=\"_blank\" href=\"https://www.autodesk.com/sign-in-activation-tur\">oturum a&ccedil;ma</a> veya <a target=\"_blank\" href=\"https://www.autodesk.com/access-with-serial-number-tur\">seri numaras\u0131 girme</a> talimatlar\u0131n\u0131 takip etmeniz yeterlidir."
    },
    signInOptional: {
      title: "Oturum a&ccedil;ın (isteğe bağlı)",
      message: "Oturum a&ccedil;mak zorunda de\u011Filsiniz ancak oturum a&ccedil;arsan\u0131z i\u015Flemi daha kolay yapabilirsiniz."
    },
    overActScreen: {
      actAgainLabel: "Tekrar etkinleştirme sebebini seçin",
      pageTitle: "3. Birden fazla etkinleştirme sebebi",
      reason1: "Yeni bilgisayar",
      reason2: "Bilgisayarım çalındı",
      reason3: "Yeniden yazılım yükleme",
      reason4: "Diğer",
      responseText: "Bu seri numarası daha önce etkinleştirilmiş.",
      selectReason: "Sebep seçme"
    }
  },
  hula: {
    welcome: {
      clickGetStarted: "Ev kullanımı seri numaranızı almak için Başlayın seçeneğine tıklayın.",
      intro: "Ev kullanım lisansını edinmek için bu hızlı adımları takip edin.",
      modalTitle: "Ev kullanım lisansı isteme",
      noteBullet1: 'Ev kullanımı, çok kullanıcılı abonelik kapsamındaki <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-tur">uygun ürünlerde</a> ve bakım anlaşması kapsamındaki ağ lisanslarında geçerlidir.',
      noteBullet2: "Tek kullanıcı abonelikleri, ev kullanımını otomatik olarak kapsar. Yazılımı, aynı seri numarasını kullanarak bir ev bilgisayarından yükleyip etkinleştirebilirsiniz."
    },
    processInfoScreen: {
      hulaEligibleVersionMsg: 'Yukarıda yalnızca uygun sürümler listelenmiştir. <a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-tur">Uygunluk gerekliliklerine bakın</a>',
      crossGradeHulaMessage: "\u0130ste\u011Finiz burada i\u015Fleme al\u0131namad\u0131. Se&ccedil;ili s&uuml;r&uuml;m i&ccedil;in ev kullan\u0131m lisans\u0131 almak i&ccedil;in l&uuml;tfen <a id=\"go-to-create-case\" href=\"javascript:void(0);\"> bir vaka olu\u015Fturun</a> 2 i\u015F g&uuml;n&uuml; i&ccedil;inde sizinle ileti\u015Fime ge&ccedil;ece\u011Fiz."
    },
    errors: {
      tokenFlexSerialNumber: "You\u2019ve entered a TokenFlex serial number. To request a home use license, please email your Autodesk Premier Expert at <strong><a href=\"mailto:premier@autodesk.com\">premier@autodesk.com</a></strong>."
    },
    requestFailedScreen: {
      hulaEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-home-use-products-tur">Uygunluk gereksinimlerine bakın</a>',
      hulaIneligible: "&Uuml;r&uuml;n&uuml;n&uuml;z ev kullan\u0131m lisans\u0131na uygun olmad\u0131\u011F\u0131 i&ccedil;in iste\u011Finiz tamamlanam\u0131yor."
    }
  },
  pv: {
    welcome: {
      clickGetStarted: "Yazılımınızın önceki sürümlerinden birine erişmek için Başlayın seçeneğine tıklayın.",
      intro: "Yazılımınızın önceki sürümlerinden birini edinmek için bu hızlı adımları takip edin.",
      modalTitle: "Önceki sürümü isteme",
      noteBullet1: 'Aboneliğiniz varsa <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">hesabınıza</a> giriş yaparak önceki sürümlerden ihtiyacınız olanı indirin.',
      noteBullet2: 'Bakım anlaşması kapsamında bağımsız bir lisansınız varsa <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-tur">uygun</a> ürünlerin önceki sürümlerini istemek için bu yöntemi kullanın.'
    },
    processInfoScreen: {
      noPvAvailable: 'Talep ettiğiniz ürünün önceki sürümleri bulunmamaktadır. Daha fazla bilgi için <a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-tur">önceki sürümlere ilişkin politikamıza</a> bakın.',
      pvEduUserMsg: 'Bir Eğitim lisansınız var. <a target="_blank" href="https://www.autodesk.com/education/free-software/all">Eğitim Topluluğu</a> sayfasına gidin, burada önceki sürümlerden en fazla üçünü indirebilirsiniz.',
      pvEligibleVersionMsg: 'Yukarıda yalnızca uygun sürümler listelenmiştir. <a target="_blank" href="https://knowledge.autodesk.com/customer-service/account-management/users-software/previous-versions/previous-version-support-policy">Uygunluk gerekliliklerine bakın</a>',
      pvMultiUserSubsMsg: "&Ccedil;ok kullan\u0131c\u0131l\u0131 bir aboneli\u011Finiz var. &Ouml;nceki s&uuml;r&uuml;mlere ait seri numaralar\u0131 <a target=\"_blank\" href=\"https://manage.autodesk.com/cep/#products-services\">hesab\u0131n\u0131zda</a> g&ouml;r&uuml;nt&uuml;lenir.",
      pvNetworkMaintenanceUserMsg: "Bir a\u011F lisans\u0131n\u0131z var. &Ouml;nceki s&uuml;r&uuml;mlere ait seri numaralar\u0131 <a target=\"_blank\" href=\"https://manage.autodesk.com/cep/#products-services\">hesab\u0131n\u0131zda</a> g&ouml;r&uuml;nt&uuml;lenir.",
      pvPerpetualUserMsg: 'Bu ürünün kalıcı lisansına önceki sürümlere erişim dahil değildir.<br/><br/>Aboneliklere, önceki sürümlere erişim dahildir. <a target="_blank" href="https://www.autodesk.com.tr/subscription">Abonelik avantajları hakkında daha fazla bilgi edinin.</a>',
      pvSingleUserSubsMsg: 'Tek kullanıcılı bir aboneliğiniz var. Önceki sürümlerden en fazla üçüne erişmek için <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">hesabınızda</a> bulunmasını istediğiniz ürünleri belirtin. ("Seri numarası alın" bağlantısını bulun.)',
      serialNumberCurrentLabel: "Mevcut seri numarası",
      versionRequestingLabel: "İstediğiniz sürüm"
    },
    errors: {
      tokenFlexSerialNumber: "You\u2019ve entered a TokenFlex serial number. To request a previous version license, please email your Autodesk Premier Expert at <strong><a href=\"mailto:premier@autodesk.com\">premier@autodesk.com</a></strong>."
    },
    requestFailedScreen: {
      pvEligibilityReqs: '<a target="_blank" href="https://www.autodesk.com/eligible-previous-versions-tur">Uygunluk gerekliliklerine bakın</a>',
      pvInactiveSubscription: 'Bu ürüne aboneliğiniz <a target="_blank" href="https://manage.autodesk.com/cep/#products-services">hesabınızda</a> artık etkin olmadığı için isteğiniz tamamlanamıyor.',
      pvIneligible: "Ürününüz önceki sürüm lisansına uygun olmadığı için isteğiniz tamamlanamıyor."
    }
  },
  cm: {
    welcome: {
      clickGetStarted: "Sözleşme yöneticinizi değiştirmek için Başlayın seçeneğine tıklayın.",
      modalTitle: "Sözleşme yöneticisini değiştir",
      noteBullet1: "Bakım anlaşmaları ve otomatik olarak yenilenmeyen aboneliklerde sözleşme yöneticisini değiştirebilirsiniz.",
      noteBullet2: "Otomatik olarak yenilenen bir aboneliğiniz varsa sözleşme yöneticisini değiştirmek için aboneliğinizi iptal ederek yeni bir abonelik başlatmanız gerekir."
    },
    processInfoScreen: {
      cmEmailPlaceholder: "Sözleşme numarasıyla ilişkili",
      contractNumDisclaimer: "S\xF6zle\u015Fme numaran\u0131zda bulunuyorsa k\u0131sa \xE7izgi karakterini (-) de ekleyin.",
      contractNumLabel: "Sözleşme numarası",
      contractNumTooltip: 'Sözleşme numarasını <a target="_blank" href="https://manage.autodesk.com">Hesabınızdaki</a> Faturalandırma ve Siparişler bölümünde bulabilirsiniz.',
      currentCmEmailLabel: "Geçerli sözleşme yöneticisinin e-posta adresi",
      newCmEmailLabel: "Yeni sözleşme yöneticisinin e-posta adresi",
      newCmNameLabel: "Yeni sözleşme yöneticisinin adı",
      newCmPhoneLabel: "Yeni sözleşme yöneticisinin telefon numarası",
      pageTitle2: "3. Yeni bilgiler",
      pageTitle: "2. Mevcut bilgiler",
      phoneNumPlaceholder: "Alan kodunu ve numarayı ekleyin"
    },
    authorizationRequestScreen: {
      option1: "Sözleşme yöneticisi olduğumu veya bu aboneliğin sahibi olan şirket tarafından bu istekte bulunabilmek için gerekli yetkinin tarafıma verildiğini onaylıyorum.",
      confirmLabel: "L&uuml;tfen bu istekte bulunmaya yetkiniz olduğunu onaylayın",
      pageTitle: "4. Bu isteğe ilişkin yetki"
    },
    successScreen: {
      cmWillReceiveEmail: "Yeni s\xF6zle\u015Fme y\xF6neticisine detayl\u0131 talimatlar\u0131 i\xE7eren bir e-posta g\xF6nderilecektir.",
      emailWillBeSent: "Şu adresinize bir onay e-postası gönderilecektir: <email>",
      responseText4: "<contract-number> s\xF6zle\u015Fme numaras\u0131n\u0131n yeni bir s\xF6zle\u015Fme y\xF6neticisi var:"
    },
    errors: {
      contractNumNotFound: "Sözleşme numarası bulunamadı",
      emailNotAssociatedWithcontractNum: "Bu e-posta adresi, yukarıdaki sözleşme numarasıyla ilişkili değildir.",
      enterContractNum: "Sözleşme numaranızı girin"
    },
    requestFailedScreen: {
      autoRenewSubs: "Kayıtlarımıza göre, otomatik olarak yenilenen bir aboneliğe sahipsiniz. Sözleşme yöneticisini değiştirmek için aboneliğinizi iptal ederek yeni bir abonelik başlatmanız gerekir.",
      autoRenewSubsTitle: "Otomatik yenilemeli abonelik",
      inactiveContract: "Sözleşmeniz etkin olmadığı için isteğiniz tamamlanamıyor.",
      inactiveContractTitle: "Etkin olmayan sözleşme"
    }
  },
  sc: {
    welcome: {
      clickGetStarted: "Yazılım koordinatörünüzü değiştirmek için Başlayın seçeneğine tıklayın.",
      modalTitle: "Yazılım koordinatörünü değiştirme",
      noteBullet1: "Bakım anlaşmaları ve aboneliklerin (eğitim ürünleri hariç) yazılım koordinatörünü değiştirmek için bu yöntemi kullanabilirsiniz."
    },
    processInfoScreen: {
      currentScEmailLabel: "Geçerli yazılım koordinatörünün e-posta adresi",
      newScEmailLabel: "Yeni yazılım koordinatörünün e-posta adresi",
      newScNameLabel: "Yeni yazılım koordinatörünün adı",
      newScPhoneLabel: "Yeni yazılım koordinatörünün telefon numarası",
      scEmailPlaceholder: "Seri numarasıyla ilişkili",
      importantInformation: "&Ouml;nemli bilgiler"
    },
    authorizationRequestScreen: {
      option1: "Sözleşme yöneticisi, yazılım koordinatörü olduğumu veya bu aboneliğin sahibi olan şirket tarafından bu istekte bulunabilmek için gerekli yetkinin tarafıma verildiğini onaylıyorum."
    },
    successScreen: {
      responseText4: "<serial-number> seri numaras\u0131n\u0131n yeni bir yaz\u0131l\u0131m koordinat\xF6r\xFC var:",
      scWillReceiveEmail: "Yeni yaz\u0131l\u0131m koordinat\xF6r\xFCne detayl\u0131 talimatlar\u0131 i\xE7eren bir e-posta g\xF6nderilecektir."
    },
    errors: {
      emailNotAssociatedWithSerialNum: "Bu e-posta adresi, yukarıdaki seri numarasıyla ilişkili değildir.",
      tokenFlexSerialNumber: "You've entered a TokenFlex serial number. To change the Software Coordinator, please email your Autodesk Premier Expert at <strong><a href=\"mailto:premier@autodesk.com\">premier@autodesk.com</a></strong>."
    },
    requestFailedScreen: {
      serialNumberIneligle: "Seri numaranız, yazılım koordinatörü değişikliğine uygun olmadığı için isteğiniz tamamlanamıyor.",
      serialNumberIneligleTitle: "Seri numarası uygun değil"
    }
  },
  ccna: {
    welcome: {
      clickGetStarted: "Şirket iletişim bilgilerinizi değiştirmek için Başlayın seçeneğine tıklayın.",
      modalTitle: "Şirket Adını veya Adresini Değiştirme",
      noteBullet1: "Sadece <strong>Sözleşme Yöneticisi olduğunuz takdirde</strong> şirket adını ve adresini değiştirebilirsiniz.",
      noteBullet2: '<strong>Bu işlem, sahipliği aktarmaz.</strong> Bir lisansı yeni bir sahibe aktarmak için <a target="_blank" href="https://knowledge.autodesk.com/tr/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">Lisans Aktarma Talebinde bulunmanız gerekir</a>.'
    },
    processInfoScreen: {
      reviewInfoTitle: "Hesap bilgilerinizi gözden geçirin",
      currentInfoTitle: "Mevcut bilgiler",
      current: "Güncel: ",
      pageTitle2: "Yeni bilgileri girin",
      pageTitleValidateAddr: "Adresi doğrulayın",
      pageTitleConfirmChanges: "Değişiklikleri onaylayın",
      changeInfoLabel: "Hangi bilgileri değiştirmek istiyorsunuz?",
      addressOption: "Adres",
      nameOption: "Şirket adı",
      nameAndAddressOption: "Hem şirket adı hem şirket adresi",
      newTaxIdLabel: "Yeni bir vergi numaranız veya İşveren Kimlik Numaranız var mı?",
      msgTOLS: 'Yukarıdaki cevaplarınıza bağlı olarak, bir lisansı yeni bir sahibe aktarmak için <a target="_blank" href="https://knowledge.autodesk.com/tr/customer-service/download-install/activate/transfer-licenses/transfer-ownership-licenses">Lisans Aktarma</a>  formunu doldurmanız gereklidir. Daha fazla desteğe ihtiyaç duyarsanız <Strong>aşağıdan müşteri desteği ile irtibata geçin.</Strong>',
      unauthorizedUser: "Bu sözleşmede değişiklik yapma yetkiniz yok.",
      msgAutoRenew: 'Otomatik yenileme, tekrarlayan faturalar ve bazı bulut tabanlı yazılım sözleşmeleri için şirket ad veya adres değişiklikleri çevrimiçi yapılamaz. Lütfen <a target="_blank" href="https://knowledge.autodesk.com/tr/customer-service/account-management/account-profile/change-company-name-and-address">şirket adınızı veya adresinizi değiştirmek</a> için bu adımları takip edin.',
      msgExpiredContract: "Bu sözleşme sona ermiştir.",
      notEligible: "Bu sözleşme uygun değildir.",
      changingInfoFor: "Numarası verilen sözleşme için bilgi değişikliği: <contract-number>",
      companyName: "Şirket adı",
      accountCSN: "Hesap CSN",
      streetAddress: "Sokak adresi",
      city: "Şehir",
      state: "İl/İlçe",
      postalCode: "Posta kodu",
      country: "Ülke",
      validateAddDisclaimer: "En iyi adres eşleşmemiz aşağıda vurgulanmıştır. Girileni seçmek, işlem süresinin uzamasına neden olabilir.",
      confirmDisclaimer: "Herhangi bir hatayı önlemek için lütfen göndermeden önce değişikliklerinizi gözden geçirin. Tüm gerekli düzenlemeler için önceki ekrana dönebilirsiniz.",
      recommendedAddr: "En İyi Adres Eşleşmesi",
      enteredAddr: "Girdiğiniz Adres",
      changeWillbeAppliedFor: "Değişiklikler, numarası verilen sözleşmeye uygulanacaktır: <contract-number>",
      new: "YENİ",
      old: "ESKİ",
      emailWillBeSent: "Şu adresinize bir onay e-postası gönderilecektir: <email>"
    },
    successScreen: {
      emailWillBeSent: "Şu adresinize bir onay e-postası gönderilecektir: <email>",
      changeAppliedFor: "<contract-number> numaralı sözleşme aşağıdaki şekilde güncellenmiştir:",
      nonCleansedAddrMsg: "Kısa bir süre içinde Destek Talebi Numaranızı içeren bir onay e-postası alacaksınız. Lütfen bu e-postayı kayıtlarınız için saklayın.<br><br><strong>İki iş günü içinde talebinize yanıt vereceğiz.</strong><br><br>Bir saat içinde onay e-postası almazsanız, Önemsiz e-postalar klasörünüzü kontrol edin veya daha fazla yardım için Ağ Yöneticiniz ile irtibata geçin."
    },
    errors: {
      contractNumNotFound: "Sözleşme numarası bulunamadı",
      invalidContractNum: "Geçersiz sözleşme numarası",
      enterContractNum: "Sözleşme numaranızı girin"
    }
  }
};